import api from './api';
import { LetterData } from '../types/letter';

class LetterService {
    async create(data: Partial<LetterData> = {}) {
        const response = await api.post('/letter/create', data);
        return response.data as LetterData;
    }

    async get(id: string) {
        const response = await api.get(`/letter/${id}`);
        return response.data as LetterData;
    }

    async update(id: string, data: Partial<LetterData>) {
        const response = await api.put(`/letter/${id}`, data);
        return response.data as LetterData;
    }

    async getUserLetters(userId: string) {
        const response = await api.get(`/letter/user/${userId}`);
        return response.data as LetterData[];
    }

    async generate(id: string) {
        const response = await api.post(`/letter/${id}/generate`);
        return response.data as LetterData;
    }

    async delete(id: string) {
        const response = await api.delete(`/letter/${id}`);
        return response.data;
    }

    async downloadPdf(id: string) {
        // Corps `{}` obligatoire : Content-Type application/json + body vide → 400 HTML Express
        const response = await api.post(
            `/letter/${id}/pdf`,
            {},
            {
                responseType: 'blob',
                validateStatus: () => true,
            }
        );
        if (response.status < 200 || response.status >= 300) {
            let message = `Échec PDF (${response.status})`;
            const data = response.data;
            if (data instanceof Blob) {
                const text = await data.text();
                try {
                    const parsed = JSON.parse(text);
                    if (parsed?.error) message = parsed.error;
                } catch {
                    if (text && !text.includes('<!DOCTYPE')) message = text.slice(0, 300);
                }
            } else if (data?.error) {
                message = data.error;
            }
            throw new Error(message);
        }
        return response.data as Blob;
    }
}

export default new LetterService();
